import React, { useState } from "react";

import { Icon, IconButton } from "../../../components/ui";
import PriceChart from "./PriceChart";
import PriceChartLegend from "./PriceChartLegend";
import PriceChartRangeFilters from "./PriceChartRangeFilters";
import PriceDetails from "./PriceDetails";
import PriceList from "./PriceList";
import { DEFAULT_PRICE_CHART_RANGE } from "./priceChartUtils";
import "./price-chart.scss";

const ProductPricesView = ({
  user,
  product,
  prices,
  analytics,
  filters,
  onFiltersChange,
  refresh,
  basePath,
  variant = undefined,
  isLoadingPrices = false,
  errorPrices = null,
}) => {
  const [dateRange, setDateRange] = useState(DEFAULT_PRICE_CHART_RANGE);

  return (
    <div
      className={`product-prices-display flex-grow-1${
        variant ? " rc-product-pricing" : ""
      }${variant === "standalone" ? " rc-product-pricing--standalone" : ""}`}
    >
      <div className="rc-product-pricing__header">
        <div className="rc-product-pricing__header-start">
          <h2 className="rc-product-pricing__title">Price analysis</h2>
          <PriceChartRangeFilters value={dateRange} onChange={setDateRange} />
          <PriceChartLegend />
        </div>
        <IconButton
          variant="ghost"
          label="Refresh price data"
          title="Refresh price data"
          data-btn="price-refresh"
          onClick={refresh}
        >
          <Icon name="RefreshCw" size="sm" />
        </IconButton>
      </div>
      <div className="chart-line d-flex">
        <div className="chart flex-grow-1">
          <PriceChart
            prices={prices}
            dateRange={dateRange}
            isLoading={isLoadingPrices}
            error={errorPrices}
          />
        </div>
        <div className="price-details">
          <PriceDetails
            {...{
              user,
              analytics,
            }}
          />
        </div>
      </div>
      <div className="rc-product-pricing__history">
        <h3 className="rc-product-pricing__section-title">Trading history</h3>
        <PriceList
          {...{
            user,
            product,
            onFiltersChange,
            filters,
            basePath,
          }}
        />
      </div>
    </div>
  );
};

export default ProductPricesView;
